<template>
  <div class="sidebar">
    <div v-if="isPanelOpen" class="sidebar-backdrop" @click="closeSidebarPanel"></div>
    <transition name="slide">
      <div v-if="isPanelOpen" class="sidebar-panel shadow">
        <slot />
      </div>
    </transition>
  </div>
</template>
<script>
import Hammer from 'hammerjs';
export default {
  name: 'Sidebar',
  mounted() {
    const swipe = new Hammer(document.getElementById('app'));
    let that = this;
    swipe.on('panleft panright', function(e) {
      e.preventDefault();
      const { x } = that.getStartPosition(e);
      if (e.type === 'panright' && x >= 0 && x <= 50) {
        that.isPanelOpen = true;
      }
    });
  },
  data: () => ({
    isPanelOpen: false,
  }),
  watch: {
    isPanelOpen() {
      this.$emit('toggled', this.isPanelOpen);
    },
  },
  methods: {
    closeSidebarPanel() {
      this.isPanelOpen = false;
    },
    toggle() {
      this.isPanelOpen = !this.isPanelOpen;
    },
    getStartPosition(e) {
      const delta_x = e.deltaX;
      const delta_y = e.deltaY;
      const final_x = e.srcEvent.pageX || e.srcEvent.screenX || 0;
      const final_y = e.srcEvent.pageY || e.srcEvent.screenY || 0;

      return {
        x: final_x - delta_x,
        y: final_y - delta_y,
      };
    },
  },
};
</script>
<style>
.slide-enter-active,
.slide-leave-active {
  transition: transform 0.2s ease;
}

.slide-enter,
.slide-leave-to {
  transform: translateX(-100%);
  transition: all 150ms ease-in 0s;
}

.sidebar-backdrop {
  background-color: rgba(0, 0, 0, 0.1);
  width: 100vw;
  height: 100vh;
  position: fixed;
  top: 0;
  left: 0;
  cursor: pointer;
  backdrop-filter: blur(2px);
  z-index: 99999;
}

.sidebar-panel {
  overflow-y: auto;
  background-color: white;
  position: fixed;
  left: 0;
  top: 0;
  height: 100vh;
  z-index: 999999;
  padding: 3rem 0 0 0;
  width: 300px;
}
</style>
